"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NQInternalErrorCode = exports.NQInternalError = exports.NQError = exports.NQErrorCode = void 0;
var immer_1 = require("immer");
var NQErrorCode;
(function (NQErrorCode) {
    NQErrorCode[NQErrorCode["Server"] = 0] = "Server";
    NQErrorCode[NQErrorCode["Client"] = 1] = "Client";
    NQErrorCode[NQErrorCode["Connectivity"] = 2] = "Connectivity";
    NQErrorCode[NQErrorCode["SystemUnderMaintenance"] = 3] = "SystemUnderMaintenance";
    NQErrorCode[NQErrorCode["RateLimit"] = 4] = "RateLimit";
    NQErrorCode[NQErrorCode["ParallelSpeedtests"] = 5] = "ParallelSpeedtests";
})(NQErrorCode = exports.NQErrorCode || (exports.NQErrorCode = {}));
var NQError = /** @class */ (function () {
    function NQError(code, debugMessage, // Not to be shown to users
    cause) {
        if (debugMessage === void 0) { debugMessage = null; }
        if (cause === void 0) { cause = null; }
        this.code = code;
        this.debugMessage = debugMessage;
        this.cause = cause;
        this.message = messageForCode(code);
        this.name = "NQError";
        (0, immer_1.freeze)(this);
    }
    return NQError;
}());
exports.NQError = NQError;
function messageForCode(code) {
    switch (code) {
        case NQErrorCode.Server:
            return "Der Speedtest-Server steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später noch einmal.";
        case NQErrorCode.Client:
            return "Ein interner Fehler ist aufgetreten.";
        case NQErrorCode.Connectivity:
            return "Probleme mit der Internet-Verbindung erkannt. Stellen Sie sicher, dass die Verbindung funktioniert.";
        case NQErrorCode.SystemUnderMaintenance:
            return "Das System wird zurzeit gewartet. Bitte versuchen Sie es später noch einmal.";
        case NQErrorCode.RateLimit:
            return "Du hast die maximal zulässige Anzahl von Speedtests für heute erreicht. Ab morgen steht Dir unser System wieder zur Verfügung. Die Begrenzung dient dem Schutz unseres Netzes und anderer Nutzer.";
        case NQErrorCode.ParallelSpeedtests:
            return "Wir haben festgestellt, dass möglicherweise bereits ein Speedtest von diesem Anschluss durchgeführt wird. Bitte wart in ein paar Minuten vor dem Start eines neuen Speedtests.";
    }
}
var NQInternalError = /** @class */ (function () {
    function NQInternalError(internalCode, message, debugMessage, // Not to be shown to users
    cause) {
        if (debugMessage === void 0) { debugMessage = null; }
        if (cause === void 0) { cause = null; }
        this.internalCode = internalCode;
        this.message = message;
        this.debugMessage = debugMessage;
        this.cause = cause;
        this.name = "NQInternalError";
        (0, immer_1.freeze)(this);
    }
    return NQInternalError;
}());
exports.NQInternalError = NQInternalError;
var NQInternalErrorCode;
(function (NQInternalErrorCode) {
    NQInternalErrorCode["RemotePortDetection"] = "RemotePortDetection";
    NQInternalErrorCode["MissingNQValueDuringSave"] = "MissingNQValueDuringSave";
    NQInternalErrorCode["IllegalBenchmarkResultsValues"] = "IllegalBenchmarkResultsValues";
    NQInternalErrorCode["DownloadError"] = "DownloadError";
    NQInternalErrorCode["DownloadTimeout"] = "DownloadTimeout";
    NQInternalErrorCode["UploadError"] = "UploadError";
    NQInternalErrorCode["UploadTimeout"] = "UploadTimeout";
})(NQInternalErrorCode = exports.NQInternalErrorCode || (exports.NQInternalErrorCode = {}));
//# sourceMappingURL=NQError.js.map